export const UNCONFIRMED_LOBBY_RESULT =
  'No pudimos confirmar el resultado. Recargá el viaje antes de reintentar.'

const countOf = value => (Number.isInteger(value) && value > 0 ? value : 0)

const sourceOf = value => (value && typeof value === 'object' ? value : {})

const line = (text, tone = 'neutral') => ({ text, tone })

export const cancelSummaryLines = summary => {
  const source = sourceOf(summary)
  const choice = countOf(source.choice)
  const refunded = countOf(source.refunded)
  const already = countOf(source.already)
  const failed = countOf(source.failed)
  const free = countOf(source.free)
  return [
    choice > 0 &&
      line(
        `${choice} ${choice === 1 ? 'pasajero tiene' : 'pasajeros tienen'} 24 h para elegir cómo recibir el reembolso.`
      ),
    refunded > 0 && line(`${refunded} ${refunded === 1 ? 'reembolsado' : 'reembolsados'}.`),
    already > 0 && line(`${already} ya ${already === 1 ? 'tenía' : 'tenían'} el reembolso hecho.`),
    failed > 0 && line(`${failed} con error en el reembolso: revisá el mail de pagos.`, 'alert'),
    free > 0 && line(`${free} ${free === 1 ? 'viajaba' : 'viajaban'} gratis: no había nada para reembolsar.`)
  ].filter(Boolean)
}

export const restoreSummaryLines = choices => {
  const source = sourceOf(choices)
  const resolved = countOf(source.resolved)
  const unconfirmed = countOf(source.unconfirmed)
  return [
    source.failed === true &&
      line('No pudimos revisar las elecciones de reembolso: revisá el mail de pagos.', 'alert'),
    resolved > 0 &&
      line(
        `${resolved} ${
          resolved === 1 ? 'pasajero volvió' : 'pasajeros volvieron'
        } con el reembolso hecho o en curso: revisá el mail de pagos.`,
        'alert'
      ),
    unconfirmed > 0 &&
      line(
        `${unconfirmed} ${
          unconfirmed === 1 ? 'elección' : 'elecciones'
        } de reembolso sin confirmar: revisá el mail de pagos.`,
        'alert'
      )
  ].filter(Boolean)
}

const LINE_TONES = {
  neutral: 'text-espresso dark:text-gray-200',
  alert: 'font-semibold text-coral_deep dark:text-red-400'
}

export default function LobbyActionResult({ loading, ok, title, lines }) {
  if (loading) return <>Cargando...</>
  if (!ok) {
    return (
      <div role='alert' className='text-amber-700 dark:text-amber-400 font-bold text-lg'>
        {UNCONFIRMED_LOBBY_RESULT}
      </div>
    )
  }
  return (
    <div role='status' className='flex flex-col gap-3'>
      <div className='text-green-700 dark:text-emerald-400 font-extrabold text-2xl'>{title}</div>
      {lines.length > 0 && (
        <ul className='flex flex-col gap-1.5 text-base'>
          {lines.map(item => (
            <li key={item.text} className={LINE_TONES[item.tone]}>
              {item.text}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
